<template>
    <div class="topics-container">
        <!-- SearchBar -->
        <div class="search-section">
            <div class="search-container">
                <el-row :gutter="10">
                    <el-col :span="5">
                        <el-input 
                            placeholder="Search Topic ID" 
                            v-model="searchTip.ID" 
                            @clear="getTopics()"
                            @keyup.enter.native="getTopics()"
                            clearable
                            size="medium">
                            <el-button slot="append" icon="el-icon-search" @click="getTopics()"></el-button>
                        </el-input>
                    </el-col>
                    <el-col :span="5">
                        <el-input 
                            placeholder="Search English Name" 
                            v-model="searchTip.EN" 
                            @clear="getTopics()"
                            @keyup.enter.native="getTopics()"
                            clearable
                            size="medium">
                        </el-input>
                    </el-col>
                    <el-col :span="5">
                        <el-input 
                            placeholder="Search Chinese Name" 
                            v-model="searchTip.ZH" 
                            @clear="getTopics()"
                            @keyup.enter.native="getTopics()"
                            clearable
                            size="medium">
                        </el-input>
                    </el-col>
                    <el-col :span="5">
                        <el-input 
                            placeholder="Search Uyghur Name" 
                            v-model="searchTip.UG" 
                            @clear="getTopics()"
                            @keyup.enter.native="getTopics()"
                            clearable
                            size="medium">
                        </el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="adding()" size="medium">
                            <i class="el-icon-plus"></i> 新增
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- Table -->
        <div class="table-container">
            <el-table 
                :data="topicList" 
                border 
                :header-cell-class-name="'headerBg'"
                class="custom-table"
                style="width: 100%">
                <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
                <el-table-column prop="topicID" label="Topic ID" width="100" align="center"></el-table-column>
                <el-table-column prop="topicEN" label="English" align="center"></el-table-column>
                <el-table-column prop="topicZH" label="Chinese" align="center"></el-table-column>
                <el-table-column prop="topicUG" label="Uyghur" align="center"></el-table-column>
                <el-table-column prop="created_at" label="Created Time" align="center"></el-table-column>
                <el-table-column prop="updated_at" label="Updated Time" align="center"></el-table-column>
                <el-table-column label="Actions" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" @click="editing(scope.row)">
                            <i class="el-icon-edit"></i> 编辑
                        </el-button>
                        <el-popconfirm 
                            class="ml-5" 
                            confirm-button-text='确定' 
                            cancel-button-text='我再想想' 
                            icon="el-icon-info" 
                            icon-color="red" 
                            title="确定删除？" 
                            @confirm="deleting(scope.row.id)">
                            <el-button type="danger" size="small" slot="reference">
                                <i class="el-icon-remove-outline"></i> 删除
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- EditBox -->
        <el-dialog 
            title="Topic" 
            :visible.sync="showEditBox" 
            :width="isMobile ? '85%' : '30%'"
            class="custom-dialog"
            :fullscreen="false"
            :close-on-click-modal="false"
            custom-class="mobile-dialog">
            <el-form label-width="65px" size="small" class="edit-form">
                <el-form-item label="Topic ID">
                    <el-input v-model="form.topicID" placeholder="Enter Topic ID"></el-input>
                </el-form-item>
                <el-form-item label="English">
                    <el-input v-model="form.topicEN" placeholder="Enter English Name"></el-input>
                </el-form-item>
                <el-form-item label="Chinese">
                    <el-input v-model="form.topicZH" placeholder="Enter Chinese Name"></el-input>
                </el-form-item>
                <el-form-item label="Uyghur">
                    <el-input v-model="form.topicUG" placeholder="Enter Uyghur Name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" :class="{ 'mobile-footer': isMobile }">
                <el-button @click="editCancel()" :class="{ 'mobile-button': isMobile }">取 消</el-button>
                <el-button type="primary" @click="editDone()" :class="{ 'mobile-button': isMobile }">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil';

export default {
    data() {
        return {
            form: {},
            topicList: [],
            showEditBox: false,
            searchTip: { ID: "", EN: "", ZH: "", UG: "" },
            isMobile: window.innerWidth <= 768
        }
    },
    created() {
        this.getTopics()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth <= 768
        },
        getTopics(){
            this.request.get("/motivo/admin/topics", { params: this.searchTip }).then(res =>{
                this.topicList = res.map(data => ({
                    id: data.id,
                    topicID: data.topic_id,
                    topicEN: data.topic_en,
                    topicZH: data.topic_zh,
                    topicUG: data.topic_ug,
                    created_at: formatDateTime(data.created_at),
                    updated_at: formatDateTime(data.updated_at),
                }))
            }).catch(res => {
                this.$message.error(res?.message || "获取数据失败")
            })
        },
        adding(){
            this.form = {}
            this.showEditBox = true
        },
        editing(row) {
            this.form = row
            this.showEditBox = true
        },
        editDone(){
            this.request.post("/motivo/admin/topics/edit", { params: this.form }).then(res => {
                if (res) {
                    this.$message.success("编辑成功")
                    this.showEditBox = false
                    this.getTopics()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(res => {
                this.$message.error(res?.message || "编辑失败")
            })
        },
        editCancel(){
            this.getTopics()
            this.showEditBox = false
        },
        deleting(id){
            this.request.delete("/motivo/admin/topics/delete/" + id).then(res => {
                if (res) {
                    this.$message.success("删除成功")
                    this.getTopics()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(res => {
                this.$message.error(res?.message || "删除失败")
            })
        }
    },
}
</script>

<style scoped>
.topics-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-section {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
}

.table-container {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow-x: auto;
}

.custom-table {
    border-radius: 8px;
    overflow: hidden;
    min-width: 800px;
}

.custom-table ::v-deep .el-table__header-wrapper {
    background-color: #f5f7fa;
}

.custom-table ::v-deep .el-table__header th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
}

.custom-table ::v-deep .el-table__row:hover {
    background-color: #f5f7fa;
}

.el-table__row .cell {
    font-size: 14px;
    word-break: keep-all !important;
}

.el-input__inner {
    word-break: keep-all !important;
}

/* Mobile Dialog Styles */
.mobile-dialog ::v-deep .el-dialog {
    margin: 15vh auto !important;
    border-radius: 12px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

.mobile-dialog ::v-deep .el-dialog__header {
    padding: 12px 15px;
    border-bottom: 1px solid #ebeef5;
}

.mobile-dialog ::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.mobile-dialog ::v-deep .el-dialog__body {
    padding: 0;
    flex: 1;
    overflow-y: auto;
}

.edit-form {
    padding: 15px;
}

.edit-form ::v-deep .el-form-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.edit-form ::v-deep .el-form-item__label {
    font-size: 14px;
    color: #606266;
    line-height: 36px;
    height: 36px;
    padding: 0 8px 0 0;
}

.edit-form ::v-deep .el-form-item__content {
    flex: 1;
    line-height: 36px;
    margin-left: 0 !important;
}

.edit-form ::v-deep .el-input__inner {
    height: 36px;
    font-size: 14px;
    padding: 0 12px;
    line-height: 36px;
}

.mobile-footer {
    padding: 12px 15px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    gap: 12px;
}

.mobile-button {
    flex: 1;
    height: 36px;
    font-size: 14px;
    border-radius: 6px;
    padding: 0 15px;
    line-height: 36px;
}

/* Media Queries */
@media screen and (min-width: 768px) {
    .topics-container {
        padding: 20px;
    }

    .table-container {
        padding: 20px;
    }

    .mobile-dialog ::v-deep .el-dialog {
        margin: 15vh auto !important;
    }

    .edit-form ::v-deep .el-form-item__label {
        padding: 0 6px 0 0;
    }

    .mobile-button {
        height: 32px;
        line-height: 32px;
    }
}
</style>
